import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// components
import AppHeader from "../../../components/common/appHeader/AppHeader";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import Blank from "../../../components/common/blank/Blank";

// utils
import toast from "@src/utils/toast";
import useUrlQueryString from "../../../utils/hooks/useUrlQueryString";
import { setInPath, setOrigin } from "@src/@slice/recommendHallSlice";
import { HOSTNAME, isExternalUrl } from "@src/utils";

//이미지
import image1 from '@assets/images/recommend/weddinghall/start1.png';
import image2 from '@assets/images/recommend/weddinghall/start2.png';
import image3 from '@assets/images/recommend/weddinghall/start3.png';
import image4 from '@assets/images/recommend/weddinghall/start4.png';

// API
import { getRecommendHallList } from "@src/api/recommend/recommend";


const Start = () => {
  const navigate = useNavigate();
  const query = useUrlQueryString();
  const origin = query.get("origin");
  const inpath = query.get("inpath");
  const dispatch = useDispatch();
  const goNext = () => {
    navigate("/recommend/hall/style");
  };

  useEffect(() => {
    if (inpath) {
      dispatch(setInPath({ inpath: inpath.toUpperCase() }));
    }
    if (origin) {
      dispatch(setOrigin({ origin: origin.substring(0, 10) }));
    }
  }, []);
  useEffect(() => {
    getRecommendHallList().then((res) => {
      if (res.data.item.length > 0) {
        toast.success('😀 신청하신 웨딩홀 추천 리스트가 있어요!', {
          isSnackbar: true,
          customToastId: 'recommendHallList',
          removeTime: 3600000, // 계속 띄워두기
          link: { url: isExternalUrl(`${HOSTNAME}/recommend/hall/my-list?hidetop=true`),text:'' },
          bottomPosition: 100
        });
      }
    }).catch((err) => {
      console.error(err);
      toast.error('추천 리스트 조회 실패', {
        isSnackbar: true,
        customToastId: 'recommendHallList',
        removeTime: 3000,
        bottomPosition: 100
      });
    });

		return () => {
			toast.remove('recommendHallList');
		}
  }, []);
  return (
    <>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <div className={`layout-fix-button with-app-header`}>
        <div>
          <PageTitle
            title={`나에게 딱 맞는 \n웨딩홀 리스트 받아보기`}
          />
          <div className="common-wrap">
            <p style={{color: '#505050', fontSize:'13px', margin:'8px 0'}}>
            결혼 준비 첫걸음 웨딩홀부터<br/>
            준비는 간편하게 혜택은 풍성하게
            </p>
          </div>
        <div className="loop_banner_wrap">
          <ul className="banner_list n1">
            <li className="banner">
              <img src={image1} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image2} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image3} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image4} alt="img_1"/>
            </li>
          </ul>
          <ul className="banner_list n2">
          <li className="banner">
              <img src={image1} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image2} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image3} alt="img_1"/>
            </li>
            <li className="banner">
              <img src={image4} alt="img_1"/>
            </li>
          </ul>
        </div>
        </div>

        <div>
          <Blank height={10} />
          <div className="btn-wrap">
            <button onClick={goNext} className={`btn btn-giant btn-red500 btn-full`}>
              맞춤 웨딩홀 추천 받기
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Start;
